import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { SucursalProvider } from './context/SucursalContext';
import App from './App';
import './styles/index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <SucursalProvider>
        <App />
      </SucursalProvider>
    </BrowserRouter>
  </React.StrictMode>
);
